import React from 'react';

//logo on the top
function UpperLogo() {
  return (
    <div className='flex items-center class="shadow-xl" content-center justify-center my-6'>
        <img src= 'https://i.postimg.cc/VNW6VQV6/Pics-Art-10-11-05-38-40.png' height={200} width={200} alt="logo" />
    </div>
  )
}

export default UpperLogo;